import * as globals from '@wandb/common/css/globals.styles';
import {
  GRAY_300,
  GRAY_500,
  RED_DARK,
  RED_LIGHT,
  TEAL_DARK,
  TEAL_LIGHT,
} from '@wandb/common/css/globals.styles';
import {WBIcon, WBIconButton} from '@wandb/ui';
import {Button, Icon} from 'semantic-ui-react';
import styled from 'styled-components';

import {GLOBAL_COLORS} from '../../../../util/colors';
import {InlineMarkdownEditor} from '../../../elements/InlineMarkdownEditor';
import {Icon as NewIcon} from '../../../Icon/Icon';

export const OverviewWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  // Hide scrollbars
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;
export const OverviewPanel = styled.div`
  min-width: 50px;
  flex: 1 0 50px;
  height: 100%;
`;
export const OverviewItem = styled.div`
  display: flex;
  min-height: 36px;
  align-items: top;
  flex: 1 1 auto;
  width: 100%;
`;
export const OverviewKey = styled.div`
  flex: 0 0 166px;
  color: ${GLOBAL_COLORS.lightGray.toString()};
`;
export const OverviewValue = styled.div`
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* margin-right: 35px; */

  .copyable-text {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .artifact-add-alias-button {
    height: 26px;
    width: 26px;
    text-align: center;
    margin: 0;
    color: ${GLOBAL_COLORS.gray.toString()};
    font-size: 18px;
    padding: 0px;
  }
`;

export const OverviewValueMarkdownEditor = styled(InlineMarkdownEditor)`
  white-space: normal;
  cursor: pointer;
`;
export const OverviewPanelSectionVersionSelection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-content: flex-start;
  [role='combobox'] > [role='listbox'] {
    max-height: 200px !important;
    & > [role='option'] {
      padding: 0.6em 1em !important;
    }
  }
`;
export const OverviewPanelSectionHeaderControls = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
export const VersionMenuButton = styled(WBIcon)`
  font-size: 1.9em;
  border-radius: 5px;
  &:hover {
    background-color: #eee;
  }
  &:active {
    background-color: #ddd;
  }
`;
export const OverviewPanelSectionBodyColumn = styled.div`
  flex: 1 1 100px;
  width: 100px;
`;
export const OverviewPanelSectionBodyRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
export const OverviewPanelSectionBody = styled.div`
  border: 1px solid #e0e0e0;
  padding: 0.5em;
  border-radius: 5px;
`;
export const OverviewPanelSection = styled.div``;
export const OverviewPanelSectionHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.2em;
  font-weight: 500;
  .ui.button {
    margin-left: 15px;
  }
`;
export const OverviewPanelSectionHeader = styled.div`
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 2;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  line-height: 32px;
  margin-bottom: 12px;
`;

export const OverviewPanelAliasContainer = styled.div`
  display: flex;
  max-height: 84px;
  overflow-y: scroll;
  margin-bottom: 8px;
  margin-left: -2px;
`;

export const CustomWBIconButton = styled(WBIconButton)`
  flex: 0 0 auto;

  .MuiIcon-root {
    font-size: 1.2rem;
  }
`;

export const GrayIcon = styled(Icon)`
  color: ${globals.gray600};
`;

export const CurrentAliasesContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 15px;
`;

export const ValidatedInputDiv = styled.div<{isError: boolean}>`
  & > input {
    border: ${p =>
      p.isError
        ? '1px solid ' + RED_LIGHT + ' !important'
        : '1px solid ' + GRAY_300 + ' !important'};
  }
`;

export const ErrorMessageContainer = styled.div<{isError: boolean}>`
  margin-top: 8px;
  font-size: 14px;
  color: ${p => (p.isError ? RED_DARK : GRAY_500)};
`;

export const LinkButton = styled(Button)`
  width: 95px;
`;

export const CurrentAliasList = styled.div`
  margin-top: 10px;
  margin-bottom: 30px;
`;

export const SettingsOverviewText = styled.div<{
  mainText?: boolean;
  size?: 'small' | 'medium';
}>`
  ${(props: any) => (props.mainText ? `` : `color: ${GRAY_500};`)}
  font-weight: 400;
  font-size: ${(props: any) => (props.size === 'medium' ? '20px' : '16px')};
  line-height: 22px;
  margin-bottom: 8px;
`;
SettingsOverviewText.displayName = 'S.SettingsOverviewText';

export const SettingsOverview = styled.div`
  display: inline-flex;
  align-content: center;
  line-height: 22px;
`;
SettingsOverview.displayName = 'S.SettingsOverview';

export const ClickableText = styled.div`
  margin-left: 4px;
  color: ${TEAL_DARK};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  cursor: pointer;
  &:hover {
    color: ${TEAL_LIGHT};
  }
`;
ClickableText.displayName = 'S.ClickableText';

export const IntegrationOverview = styled.div`
  max-width: 50px;
  margin: 10px 0px;
`;
IntegrationOverview.displayName = 'S.IntegrationOverview';

export const EmptyTriggersTable = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 240px;
  border: 1px solid #e0e0e0;
  align-items: center;
  border-radius: 5px;
`;
EmptyTriggersTable.displayName = 'S.EmptyTriggersTable';

export const TriggerContainer = styled.div`
  margin-left: auto;
`;
TriggerContainer.displayName = 'S.TriggerContainer';

export const StyledIcon = styled(NewIcon)`
  margin-right: 4px;
  vertical-align: middle;
`;
StyledIcon.displayName = 'S.StyledIcon';

export const SuccessfulLink = styled.div`
  display: flex;
  align-items: center;
`;
SuccessfulLink.displayName = 'S.SuccessfulLink';

export const SuccessfulLinkMessage = styled.div`
  margin-left: 8px;
`;
SuccessfulLinkMessage.displayName = 'S.SuccessfulLinkMessage';
